import { Grid, useMediaQuery, useTheme } from '@hermes/web-components'
import SearchResultsList, { Item } from './ResultsList'
import { MobileResultAutocomplete } from './MobileResultAutocomplete'
import { SearchResultsModalRoot } from './styles'
import useSearchBarConfig from '../../../search/hooks/useSearchBarConfig'

interface AutocompleteResultsModalProps {
  data: {
    specialties: Array<Item>
    conditionsProcedures: Array<Item>
    profiles: Array<Item>
  }
  searchString: string
  value: string
  onClose: () => void
  onChangeSearch: (...params: any) => void
  isOpen: boolean
}

const AutocompleteResultsModal = ({
  data,
  searchString,
  value,
  onClose,
  onChangeSearch,
  isOpen
}: AutocompleteResultsModalProps) => {
  const theme = useTheme()
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'))
  const { keywordsResultBubbleView } = useSearchBarConfig()

  return (
    <SearchResultsModalRoot sx={{ top: '100%', display: !isOpen ? 'none' : 'block' }}>
      {isLgDown ? (
        <MobileResultAutocomplete
          searchString={value}
          isOpen={isOpen}
          onClose={onClose}
          onChangeSearch={onChangeSearch}
        >
          <SearchResultsList
            specialties={data?.specialties}
            conditionsProcedures={data?.conditionsProcedures}
            searchString={searchString}
            bubbleView={keywordsResultBubbleView}
          />
        </MobileResultAutocomplete>
      ) : (
        <Grid container>
          <SearchResultsList
            specialties={data?.specialties}
            conditionsProcedures={data?.conditionsProcedures}
            searchString={searchString}
            bubbleView={keywordsResultBubbleView}
          />
        </Grid>
      )}
    </SearchResultsModalRoot>
  )
}

export default AutocompleteResultsModal
